import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { Ban, Trash2, Plus } from 'lucide-react';
import { api, timeAgo } from '../../lib/api';
import { SkeletonList, SectionHead, Empty } from '../../components/ui';

export default function AdminBans() {
  const qc = useQueryClient();
  const [f, setF] = useState({ ip: '', reason: '', blockUsers: true });
  const { data, isLoading } = useQuery({ queryKey: ['ipBans'], queryFn: () => api.get('/admin/ip-bans').then(r => r.data) });

  const add = useMutation({
    mutationFn: () => api.post('/admin/ip-bans', f),
    onSuccess: () => { toast.success('IP banned'); setF({ ip: '', reason: '', blockUsers: true }); qc.invalidateQueries(['ipBans']); },
    onError: e => toast.error(e.message),
  });
  const del = useMutation({
    mutationFn: (id) => api.delete(`/admin/ip-bans/${id}`),
    onSuccess: () => { toast.success('Unbanned'); qc.invalidateQueries(['ipBans']); },
  });

  return (
    <div className="space-y-4">
      <div className="card p-4">
        <SectionHead title="Ban an IP address" sub="Blocks all API access from that IP" />
        <div className="space-y-2">
          <input className="input" placeholder="192.168.1.10" value={f.ip}
            onChange={e => setF({ ...f, ip: e.target.value })} />
          <input className="input" placeholder="Reason (optional)" value={f.reason}
            onChange={e => setF({ ...f, reason: e.target.value })} />
          <label className="flex items-center gap-2 text-sm font-bold">
            <input type="checkbox" checked={f.blockUsers} className="w-4 h-4 accent-red-500"
              onChange={e => setF({ ...f, blockUsers: e.target.checked })} />
            Also block all accounts last seen on this IP
          </label>
          <button onClick={() => add.mutate()} disabled={!f.ip} className="btn w-full bg-red-500 text-white">
            <Ban size={15} /> Ban IP</button>
        </div>
      </div>

      <SectionHead title={`Banned IPs (${data?.length || 0})`} />
      {isLoading ? <SkeletonList n={4} h="h-14" />
        : !data?.length ? <Empty icon={Ban} title="No IP bans" sub="Clean house 🎉" />
        : <div className="card p-2 space-y-1">
          {data.map(b => (
            <div key={b.id} className="flex items-center gap-3 p-2.5 rounded-xl hover:bg-ink-50">
              <div className="w-9 h-9 rounded-xl bg-red-100 text-red-600 grid place-items-center"><Ban size={15} /></div>
              <div className="flex-1 min-w-0">
                <p className="font-black text-sm font-mono">{b.ip}</p>
                <p className="text-[11px] text-ink-400 font-semibold truncate">
                  {b.reason || 'No reason'} · by @{b.banned_by || 'system'} · {timeAgo(b.created_at)}
                </p>
              </div>
              <button onClick={() => del.mutate(b.id)} className="p-2 text-ink-400 hover:text-red-500 hover:bg-red-50 rounded-lg">
                <Trash2 size={15} /></button>
            </div>))}
        </div>}
    </div>
  );
}